import _ from "lodash"
import { useEffect, useMemo, useRef, useState } from "react"

export const useAsyncSearch = <T extends Record<string, any>>(
  asyncRefetch?: (searchQuery?: string) => Promise<T[]>
) => {
  const [searchValue, setSearchValue] = useState("")
  const inputRef = useRef<HTMLInputElement>(null)

  const debouncedSearch = useMemo(
    () =>
      _.debounce(async (query: string) => {
        if (asyncRefetch) {
          try {
            await asyncRefetch(query)
          } catch (error) {
            console.error(error)
          }
        }
      }, 100),
    [asyncRefetch]
  )

  useEffect(() => {
    if (searchValue === "") {
      asyncRefetch?.("")
    }
    if (searchValue && asyncRefetch) {
      debouncedSearch(searchValue)
    }
    return () => {
      debouncedSearch.cancel()
    }
  }, [searchValue, debouncedSearch, asyncRefetch])

  return {
    searchValue,
    setSearchValue,
    inputRef,
  }
}
